import * as React from "react"

function VideoCam(props) {
    return <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="73" height="73" rx="6.5" stroke="#343B45" stroke-dasharray="2 2" />
        <path d="M30 41H40L36.55 36.5L34.25 39.5L32.7 37.5L30 41ZM29 45C28.45 45 27.9792 44.8042 27.5875 44.4125C27.1958 44.0208 27 43.55 27 43V31C27 30.45 27.1958 29.9792 27.5875 29.5875C27.9792 29.1958 28.45 29 29 29H41C41.55 29 42.0208 29.1958 42.4125 29.5875C42.8042 29.9792 43 30.45 43 31V35.5L47 31.5V42.5L43 38.5V43C43 43.55 42.8042 44.0208 42.4125 44.4125C42.0208 44.8042 41.55 45 41 45H29ZM29 43H41V31H29V43Z" fill="#6D7887" />
    </svg>

}

export default VideoCam
